import { breakpoint } from "src/constants/breakpoints"

export const detailsBreakpoint = breakpoint.mediumUp
